import React, { useCallback, useEffect, useRef, useState } from "react";
import DW20Joining from "./screens/DW20Joining";
import DW20Playing from "./screens/DW20Playing";
import DW20PrePlay from "./screens/DW20PrePlay";
import DW20Result from "./screens/DW20Result";
import DWModal from "./components/DWModal";
import DW20Over from "./screens/DW20Over";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "redux/loader/action";
import _ from "lodash";
import Socket from "socket";
import { set_dw20_new_card } from "redux/game/action";
import DW20Reading from "./screens/DW20Reading";
import DW20Evaluating from "./screens/DW20Evaluating";
import { getRandomJokes } from "shared/api/jokes";
import useSound from "use-sound";
import { AnimatePresence } from "framer-motion/dist/framer-motion";

const DW20 = () => {
  const cardsRef = useRef(null);
  const dispatch = useDispatch();
  const [joke, setJoke] = useState("Loading....");
  const [showModalData, setshowModalData] = useState({});
  const {
    gameReducer: {
      currentUser,
      dw20_new_card,
      roomObj: {
        users,
        id,
        game_state: {
          status,
          prompt,
          game_outputs,
          player_hands,
          played_cards,
          active_player
        } = {}
      }
    },
    paramsReducer: {
      gameObj: { screens } = {},
      paramsObj: { default_audio_effect } = {}
    }
  } = useSelector((state) => state);
  const [buzzer_sound] = useSound(default_audio_effect);

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const isCzarPlayer = currentPlayer?.player_id === active_player;
  const winner_player = played_cards?.find((user) => user?.winner);
  const winnerPlayerInfo = users?.find(
    (user) => user.player_id === winner_player?.player_id
  );
  const winnerCard = played_cards?.find((card) => card?.winner);
  const isPlayerSubmitCard =
    played_cards?.find(
      (user) => user?.player_id === currentPlayer?.player_id
    ) || {};
  const isWinnerPlayer = currentPlayer?.player_id === winner_player?.player_id;
  const winnerScore = player_hands?.find(
    (card) => card.player_id === winner_player?.player_id
  );
  const currentPlayerCard = player_hands?.find(
    (card) => card.player_id === currentPlayer?.player_id
  );
  const handleIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  const handle_play_card = (res) => {
    if (res && res.room && !_.isEmpty(res.cardId)) {
      handleIsLoading(false);
      const player_cards = res.room.game_state.player_hands.find(
        (card) => card.player_id === currentPlayer.player_id
      ).cards;

      const newCard = player_cards?.find((newCard) =>
        cardsRef.current.every((prevCard) => prevCard.id !== newCard.id)
      );

      setshowModalData({});
      !_.isEmpty(newCard) &&
        dispatch(set_dw20_new_card({ active: true, card: newCard }));
    }
  };

  const handle_play_card_error = (err) => {
    if (err) {
      handleIsLoading(false);
    }
  };

  const handleSetModalCard = (item) => {
    setshowModalData(item);
  };

  const handleNewCard = () => {
    dispatch(set_dw20_new_card({ active: false, card: {} }));
  };
  const confirmButtonPressAction = () => {
    handleIsLoading(true);
    const data = {
      action: "play-card",
      roomId: id,
      cardId: showModalData?.id || "",
      playerId: currentPlayer?.player_id || ""
    };
    Socket.sendMessage(data);
    setshowModalData({});
  };

  const handleConfirmClick = useCallback(
    _.debounce((type) => confirmButtonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [id, showModalData]
  );

  const handleWinner = () => {
    handleIsLoading(true);

    const data = {
      action: "select-card",
      roomId: id,
      cardId: showModalData.id
    };
    Socket.sendMessage(data);
    setshowModalData({});
  };
  const updateRoomForNextRound = () => {
    const data = {
      action: "update-status",
      roomId: id
    };
    Socket.sendMessage(data);
  };
  useEffect(() => {
    getRandomJokes().then((data) => setJoke(data));
  }, [status]);
  useEffect(() => {
    if (status === "Playing") {
      cardsRef.current = currentPlayerCard.cards;
      dispatch(set_dw20_new_card({ active: false, card: {} }));
    }
  }, [status]);

  useEffect(() => {
    return Socket.addListener(
      "play-card",
      handle_play_card,
      handle_play_card_error,
      () => handleSetModalCard({})
    );
  }, [cardsRef]);
  useEffect(() => {
    return Socket.addListener("select-card", handle_play_card_error);
  }, [status]);

  useEffect(() => {
    if (
      status === "Joining" ||
      status === "PrePlay" ||
      status === "Result" ||
      status === "Over"
    ) {
      handleNewCard();
    }
  }, [status]);
  return (
    <div className="dw-main">
      <div className="dw-content">
        <AnimatePresence exitBeforeEnter>
          {status === "Joining" && <DW20Joining key="DW20_0" users={users} />}
          {status === "PrePlay" && (
            <DW20PrePlay
              key="DW20_1"
              isCzarPlayer={isCzarPlayer}
              roomId={id}
              screens={screens}
              joke={joke}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Playing" && (
            <DW20Playing
              key="DW20_2"
              isCzarPlayer={isCzarPlayer}
              roomId={id}
              screens={screens}
              askedQuestion={prompt}
              playedCard={played_cards}
              currentPlayerCard={currentPlayerCard}
              handleSetModalCard={handleSetModalCard}
              joke={joke}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Reading" && (
            <DW20Reading
              key="DW20_3"
              roomId={id}
              joke={joke}
              screens={screens}
              playedCard={played_cards}
              askedQuestion={prompt}
              isCzarPlayer={isCzarPlayer}
              currentPlayerCard={currentPlayerCard}
            />
          )}
          {status === "Evaluating" && (
            <DW20Evaluating
              key="DW20_4"
              roomId={id}
              joke={joke}
              screens={screens}
              playedCard={played_cards}
              askedQuestion={prompt}
              isCzarPlayer={isCzarPlayer}
              currentPlayerCard={currentPlayerCard}
              onEvaluateCard={(card) => setshowModalData(card)}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
              handleNewCard={handleNewCard}
            />
          )}
          {status === "Result" && (
            <DW20Result
              key="DW20_5"
              roomId={id}
              joke={joke}
              screens={screens}
              isCzarPlayer={isCzarPlayer}
              isWinnerPlayer={isWinnerPlayer}
              gameOutput={game_outputs}
              onNextRound={updateRoomForNextRound}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}

          {status === "Over" && (
            <DW20Over
              key="DW20_6"
              winnerScore={winnerScore}
              winnerPlayer={winnerPlayerInfo}
            />
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence exitBeforeEnter>
        {((!_.isEmpty(showModalData) && _.isEmpty(isPlayerSubmitCard)) ||
          (status === "Result" && isCzarPlayer)) && (
          <DWModal
            key="DW20_7"
            text={showModalData?.text}
            handleConfirmClick={handleConfirmClick}
            setshowModalData={setshowModalData}
            onConfirmCard={handleWinner}
            isResultModal={status === "Result"}
            askedQuestion={prompt}
            winnerPlayer={winnerPlayerInfo}
            winnerCard={winnerCard}
            screens={screens}
          />
        )}
        {!_.isEmpty(dw20_new_card?.card) && !isCzarPlayer && (
          <DWModal
            key="DW20_8"
            screens={screens}
            text={dw20_new_card?.card?.text}
            isNewCard={true}
            handleNewCard={handleNewCard}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default DW20;
